// extracted by mini-css-extract-plugin
module.exports = {"noBr":"docs-module--noBr--1-Asp","container":"docs-module--container--1qa47"};